import React from "react";
import { CONTACT } from "../config/contact";

const CONTACT_CONFIG = {
  whatsapp: {
    href: CONTACT.WHATSAPP_URL,
    defaultEventLabel: "whatsapp",
    defaultEventName: "Lead",
    openInNewTab: true,
  },
  whatsappBotarga: {
    href: CONTACT.WHATSAPPBOTARGA_URL,
    defaultEventLabel: "whatsappBotarga",
    defaultEventName: "Lead",
    openInNewTab: true,
  },
  email: {
    href: CONTACT.EMAIL_URL,
    defaultEventLabel: "email",
    defaultEventName: "Contact",
    openInNewTab: true,
  },
};

export default function TrackedContactLink({
  kind = "whatsapp",
  children,
  className = "",
  eventName,
  eventLabel,
  eventData = {},
  href,
  openInNewTab,
  ...props
}) {
  const config = CONTACT_CONFIG[kind] || CONTACT_CONFIG.whatsapp;
  const finalHref = href || config.href;
  const finalEventLabel = eventLabel || config.defaultEventLabel;
  const finalEventName = eventName || config.defaultEventName;
  const shouldOpenInNewTab =
    typeof openInNewTab === "boolean" ? openInNewTab : config.openInNewTab;

  const handleClick = () => {
    if (window.fbq) {
      window.fbq("track", finalEventName, {
        button_location: finalEventLabel,
        contact_type: kind,
        ...eventData,
      });
    }
  };

  const linkProps = shouldOpenInNewTab
    ? { target: "_blank", rel: "noopener noreferrer" }
    : {};

  return (
    <a
      href={finalHref}
      className={className}
      onClick={handleClick}
      {...linkProps}
      {...props}
    >
      {children}
    </a>
  );
}